(function () {
  const viewersEl = document.querySelector('[data-co-viewers]');
  if (viewersEl) {
    const base = parseInt(viewersEl.dataset.base || '89', 10);
    const variance = parseInt(viewersEl.dataset.variance || '38', 10);
    viewersEl.textContent = base + Math.floor(Math.random() * variance) + ' viewing now';
  }

  const toast = document.getElementById('co-purchase-toast');
  const toastText = toast?.querySelector('[data-co-toast-text]');
  const toastTime = toast?.querySelector('[data-co-toast-time]');
  const toastAvatar = toast?.querySelector('[data-co-toast-avatar]');

  if (toast && toastText && toastTime && toastAvatar) {
    const users = [
      { name: 'Sarah', city: 'Texas', bundle: 'Buy 2 Get 1 bundle', face: 'https://randomuser.me/api/portraits/med/women/44.jpg' },
      { name: 'Michael', city: 'Florida', bundle: '3-bottle bundle', face: 'https://randomuser.me/api/portraits/med/men/45.jpg' },
      { name: 'Patricia', city: 'California', bundle: 'Buy 2 Get 1 + free gifts', face: 'https://randomuser.me/api/portraits/med/women/52.jpg' },
      { name: 'James', city: 'Ohio', bundle: 'Subscribe & Save pack', face: 'https://randomuser.me/api/portraits/med/men/51.jpg' },
      { name: 'Lisa', city: 'Georgia', bundle: 'Buy 2 Get 1 bundle', face: 'https://randomuser.me/api/portraits/med/women/56.jpg' },
      { name: 'David', city: 'Arizona', bundle: '3-bottle bundle', face: 'https://randomuser.me/api/portraits/med/men/55.jpg' },
      { name: 'Maria', city: 'New York', bundle: 'Buy 2 Get 1 + free gifts', face: 'https://randomuser.me/api/portraits/med/women/61.jpg' },
      { name: 'Robert', city: 'North Carolina', bundle: 'Subscribe & Save pack', face: 'https://randomuser.me/api/portraits/med/men/60.jpg' },
      { name: 'Jennifer', city: 'Pennsylvania', bundle: 'Buy 2 Get 1 bundle', face: 'https://randomuser.me/api/portraits/med/women/65.jpg' },
      { name: 'William', city: 'Michigan', bundle: '3-bottle bundle', face: 'https://randomuser.me/api/portraits/med/men/64.jpg' },
      { name: 'Linda', city: 'Virginia', bundle: 'Buy 2 Get 1 + free gifts', face: 'https://randomuser.me/api/portraits/med/women/68.jpg' },
      { name: 'Richard', city: 'Colorado', bundle: 'Subscribe & Save pack', face: 'https://randomuser.me/api/portraits/med/men/67.jpg' },
      { name: 'Susan', city: 'Tennessee', bundle: 'Buy 2 Get 1 bundle', face: 'https://randomuser.me/api/portraits/med/women/72.jpg' },
      { name: 'Joseph', city: 'Texas', bundle: '3-bottle bundle', face: 'https://randomuser.me/api/portraits/med/men/71.jpg' },
      { name: 'Karen', city: 'Florida', bundle: 'Buy 2 Get 1 + free gifts', face: 'https://randomuser.me/api/portraits/med/women/76.jpg' },
    ];
    const times = ['1 minute ago', '2 minutes ago', '4 minutes ago', '6 minutes ago', '9 minutes ago', '14 minutes ago'];

    const CYCLE_MS = 30000;
    const VISIBLE_MS = 5000;
    let hideTimer;
    let cycleTimer;
    let lastUserIndex = -1;

    const pickUser = () => {
      let index = Math.floor(Math.random() * users.length);
      if (users.length > 1) {
        while (index === lastUserIndex) {
          index = Math.floor(Math.random() * users.length);
        }
      }
      lastUserIndex = index;
      return users[index];
    };

    const showToast = () => {
      const user = pickUser();
      const time = times[Math.floor(Math.random() * times.length)];

      toastText.textContent = user.name + ' from ' + user.city + ' just ordered the ' + user.bundle;
      toastTime.textContent = time;
      toastAvatar.src = user.face;
      toastAvatar.alt = user.name + ' from ' + user.city;

      toast.hidden = false;
      toast.classList.remove('is-visible');
      requestAnimationFrame(() => {
        toast.classList.add('is-visible');
      });

      clearTimeout(hideTimer);
      hideTimer = setTimeout(() => {
        toast.classList.remove('is-visible');
        setTimeout(() => {
          if (!toast.classList.contains('is-visible')) {
            toast.hidden = true;
          }
        }, 350);
      }, VISIBLE_MS);
    };

    const startCycle = () => {
      if (cycleTimer) return;
      showToast();
      cycleTimer = setInterval(showToast, CYCLE_MS);
    };

    const stopCycle = () => {
      clearInterval(cycleTimer);
      cycleTimer = null;
      clearTimeout(hideTimer);
    };

    if (document.visibilityState === 'visible') startCycle();

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') startCycle();
      else stopCycle();
    });
  }
})();

(function () {
  document.querySelectorAll('[data-co-objection-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const item = btn.closest('[data-co-objection]');
      if (!item) return;
      const open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
})();

(function initKachingBundleDropdowns() {
  const templateRoot = document.getElementById('co-bundle-details');
  if (!templateRoot) return;

  const tierHtml = {};
  templateRoot.querySelectorAll('[data-bundle-tier]').forEach((panel) => {
    tierHtml[panel.dataset.bundleTier] = panel.innerHTML;
  });

  const tierFromBar = (bar) => {
    const title = (bar.querySelector('.kaching-bundles__bar-title')?.textContent || '').toLowerCase();
    const label = (bar.querySelector('.kaching-bundles__bar-label')?.textContent || '').toLowerCase();
    const combined = title + ' ' + label;
    if (combined.includes('buy 3') || combined.includes('get 2 free')) return 'tier3';
    if (combined.includes('buy 2') || combined.includes('get 1')) return 'tier2';
    return 'tier1';
  };

  window.CoBundleTier = {
    fromBar: tierFromBar,
    giftsForTier(tier) {
      if (tier === 'tier3') return ['ebook', 'diet', 'shipping'];
      if (tier === 'tier2') return ['ebook', 'diet'];
      return ['ebook'];
    },
    selectedTier() {
      const bar = document.querySelector('.kaching-bundles__bar--selected');
      return bar ? tierFromBar(bar) : 'tier1';
    },
  };

  const buildDropdown = (tier) => {
    const drop = document.createElement('div');
    drop.className = 'co-kaching-bundle-drop';
    drop.setAttribute('aria-hidden', 'true');
    drop.innerHTML =
      '<div class="co-kaching-bundle-drop__panel">' +
      '<ul class="co-pdp__bundle-details-list">' + (tierHtml[tier] || '') + '</ul>' +
      '</div>';
    return drop;
  };

  const syncDropdowns = () => {
    const block = document.querySelector('kaching-bundles-block');
    if (!block) return;

    block.querySelectorAll('.kaching-bundles__bar[data-deal-bar-id]').forEach((bar) => {
      const drop = bar.querySelector('.co-kaching-bundle-drop');
      const isSelected = bar.classList.contains('kaching-bundles__bar--selected');
      if (drop) {
        drop.classList.toggle('is-open', isSelected);
        drop.setAttribute('aria-hidden', isSelected ? 'false' : 'true');
      }
    });
  };

  const injectDropdowns = () => {
    const block = document.querySelector('kaching-bundles-block');
    if (!block) {
      setTimeout(injectDropdowns, 350);
      return;
    }

    block.querySelectorAll('.kaching-bundles__bar[data-deal-bar-id]').forEach((bar) => {
      if (bar.querySelector('.co-kaching-bundle-drop')) return;

      const wrapper = bar.querySelector('.kaching-bundles__bar-wrapper');
      const main = wrapper?.querySelector('.kaching-bundles__bar-main');
      if (!main || !wrapper) return;

      const drop = buildDropdown(tierFromBar(bar));
      main.insertAdjacentElement('afterend', drop);
    });

    syncDropdowns();

    block.addEventListener('click', (event) => {
      const bar = event.target.closest('.kaching-bundles__bar[data-deal-bar-id]');
      if (!bar) return;
      setTimeout(syncDropdowns, 30);
      setTimeout(syncDropdowns, 120);
    });

    block.addEventListener('change', () => {
      setTimeout(syncDropdowns, 30);
    });

    const observer = new MutationObserver(() => syncDropdowns());
    observer.observe(block, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectDropdowns);
  } else {
    injectDropdowns();
  }
})();

(function initKachingPriceSync() {
  const priceCurrent = document.querySelector('[data-co-price-current]');
  const atcLabel = document.querySelector('[data-co-atc-label]');
  if (!priceCurrent && !atcLabel) return;

  const priceCompare = document.querySelector('[data-co-price-compare]');
  const priceBadge = document.querySelector('[data-co-price-badge]');
  const stickyPrice = document.querySelector('[data-co-sticky-price]');
  const stickyBtn = document.querySelector('[data-co-sticky-atc]');
  const atcPrefix = atcLabel?.dataset.coAtcPrefix || 'Add to Cart';
  const atcSep = atcLabel?.dataset.coAtcSep || (atcPrefix === 'ADD TO CART' ? ' · ' : ' — ');
  const stickyPrefix = stickyBtn?.dataset.coStickyPrefix || 'Add to Cart';

  const parseMoney = (value) => {
    const amount = parseFloat(String(value || '').replace(/[^0-9.]/g, ''));
    return Number.isFinite(amount) ? amount : 0;
  };

  const selectedBar = () => {
    const block = document.querySelector('kaching-bundles-block');
    if (!block) return null;

    const checkedBar = block.querySelector('.kaching-bundles__bar[data-deal-bar-id] input:checked')?.closest('.kaching-bundles__bar');
    if (checkedBar) return checkedBar;

    return (
      block.querySelector('.kaching-bundles__bar--selected[data-deal-bar-id]') ||
      block.querySelector('.kaching-bundles__bar--selected') ||
      block.querySelector('.kaching-bundles__bar[data-deal-bar-id]')
    );
  };

  const readBarPrices = (bar) => {
    if (!bar) return { price: '', compare: '' };
    return {
      price: bar.querySelector('.kaching-bundles__bar-price')?.textContent?.trim() || '',
      compare: bar.querySelector('.kaching-bundles__bar-full-price')?.textContent?.trim() || '',
    };
  };

  const syncPrice = () => {
    const { price, compare } = readBarPrices(selectedBar());
    if (!price) return;

    if (priceCurrent) priceCurrent.textContent = price;

    const currentAmount = parseMoney(price);
    const compareAmount = parseMoney(compare);
    const hasCompare = compareAmount > currentAmount;

    if (priceCompare) {
      priceCompare.textContent = hasCompare ? compare : '';
      priceCompare.hidden = !hasCompare;
    }

    if (priceBadge) {
      if (hasCompare) {
        const pct = Math.round(((compareAmount - currentAmount) / compareAmount) * 100);
        priceBadge.textContent = 'Save ' + pct + '%';
        priceBadge.hidden = false;
      } else {
        priceBadge.hidden = true;
      }
    }

    if (atcLabel) {
      atcLabel.textContent = atcPrefix + atcSep + price;
    }

    if (stickyPrice) {
      stickyPrice.innerHTML = hasCompare ? price + ' <s>' + compare + '</s>' : price;
    }

    if (stickyBtn) {
      stickyBtn.textContent = stickyPrefix + ' — ' + price;
    }
  };

  const watchBundles = () => {
    const block = document.querySelector('kaching-bundles-block');
    if (!block) {
      setTimeout(watchBundles, 350);
      return;
    }

    syncPrice();

    block.addEventListener('click', () => {
      setTimeout(syncPrice, 30);
      setTimeout(syncPrice, 120);
    });
    block.addEventListener('change', () => setTimeout(syncPrice, 30));

    const observer = new MutationObserver(() => syncPrice());
    observer.observe(block, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchBundles);
  } else {
    watchBundles();
  }
})();

(function initGiftsUnlocked() {
  const root = document.getElementById('co-gifts-unlocked');
  if (!root) return;

  const giftOrder = ['ebook', 'diet', 'shipping'];

  const syncGifts = () => {
    const tierApi = window.CoBundleTier;
    if (!tierApi) return;

    const tier = tierApi.selectedTier();
    const unlocked = new Set(tierApi.giftsForTier(tier));

    giftOrder.forEach((gift) => {
      const item = root.querySelector(`[data-co-gift="${gift}"]`);
      if (!item) return;

      const isOn = unlocked.has(gift);
      item.classList.toggle('is-unlocked', isOn);
      item.classList.toggle('is-locked', !isOn);

      const lock = item.querySelector('.co-gifts-unlocked__lock');
      if (lock) lock.setAttribute('aria-hidden', isOn ? 'true' : 'false');
    });
  };

  const watchBundles = () => {
    const block = document.querySelector('kaching-bundles-block');
    if (!block) {
      setTimeout(watchBundles, 350);
      return;
    }

    syncGifts();

    block.addEventListener('click', () => {
      setTimeout(syncGifts, 30);
      setTimeout(syncGifts, 120);
    });
    block.addEventListener('change', () => setTimeout(syncGifts, 30));

    const observer = new MutationObserver(() => syncGifts());
    observer.observe(block, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchBundles);
  } else {
    watchBundles();
  }

  const lazyVideos = document.querySelectorAll('[data-co-lazy-video]');
  if (lazyVideos.length) {
    const loadVideo = (video) => {
      if (video.dataset.loaded) return;
      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
      });
      video.load();
      video.dataset.loaded = 'true';
      video.play().catch(() => {});
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              loadVideo(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '120px 0px', threshold: 0.1 },
      );
      lazyVideos.forEach((video) => observer.observe(video));
    } else {
      lazyVideos.forEach(loadVideo);
    }
  }
})();
